<template>
  <a-modal
    :visible="true"
    :destroy-on-close="true"
    :closable="false"
    :footer="false"
    :mask-closable="false"
    centered
    width="680px"
    wrapClassName="generating-modal"
  >
    <div class="state__image">
      <img class="character" src="@/app/register/assets/loading.png" alt="loading" />
    </div>
    <div class="state__information">
      <p class="state">Estamos creando tu equipo de trabajo</p>
      <p class="text--loading">Estará disponible en breve</p>
    </div>
  </a-modal>
</template>

<style lang="sass" scoped>
.state__information
  text-align: center
  margin-top: 40px

.state
  font-size: 24px
  font-weight: 600
  color: $gray-11
  margin-bottom: 16px

.state__image
  text-align: center

.text--loading
  color: $gray_dark_300
  font-style: oblique
  margin: 0

.character
  animation: spin 1s ease infinite

@keyframes spin
  0%
    transform: rotate(360deg)

  100%
    transform: rotate(0deg)
</style>

<style>
.generating-modal {
  z-index: 800;
}
.generating-modal .ant-modal-content {
  border-radius: 20px;
}

.generating-modal .ant-modal-body {
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
